import { StyledAlert } from "App/global-style";
import { AlertType } from "Components/Form/Alert";
import React from "react";

interface Props {
  inputId: string;
  info?: string;
  warning?: string;
  error?: string;
  success?: string;
}

export const SearchError = ({
  inputId,
  info,
  warning,
  error,
  success,
}: Props): React.ReactElement | null => {
  const attentionId = `${inputId}-attention`;

  if (typeof error === "string") {
    return (
      <StyledAlert
        marginTop="16px"
        type="error"
        title={error}
        id={attentionId}
        alertId={inputId}
        alertType={AlertType.INPUT_ERROR_ALERT}
      />
    );
  }

  if (typeof warning === "string") {
    return (
      <StyledAlert
        marginTop="16px"
        type="warning"
        title={warning}
        id={attentionId}
        alertId={inputId}
      />
    );
  }

  if (typeof success === "string") {
    return (
      <StyledAlert
        marginTop="16px"
        type="success"
        title={success}
        id={attentionId}
        alertId={inputId}
      />
    );
  }

  if (typeof info === "string") {
    return (
      <StyledAlert
        marginTop="16px"
        type="info"
        title={info}
        id={attentionId}
        alertId={inputId}
      />
    );
  }

  return null;
};
